import React from 'react'

export default function H1(props) {
    return (
        <h1 {...props}>
            {props.data}
        </h1>
    )
}
